import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { HowItWorks } from "@/components/HowItWorks";
import { Benefits } from "@/components/Benefits";
import { WhoCanApply } from "@/components/WhoCanApply";
import { ApplicationForm } from "@/components/ApplicationForm";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="min-h-screen bg-[#F7FAFC]">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Benefits />
        <WhoCanApply />
        <ApplicationForm />
      </main>
      <Footer />
    </div>
  );
}
